import { Suspense, lazy, useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { queryKeys } from '../../lib/queryKeys';

/**
 * Гейт анонса «что нового».
 *
 * Всё тяжёлое — разметка, стили, иконка — лежит в отдельном чанке и грузится
 * только когда показывать реально есть что. В обычном состоянии (анонс в
 * админке не включён) в главный бандл попадает лишь этот файл, а на экран
 * не приходит ничего.
 */
const AnnouncementModalView = lazy(() =>
  import('./AnnouncementModalView').then((m) => ({ default: m.AnnouncementModalView })),
);

export function AnnouncementModal() {
  // Запрос откладываем до простоя: анонс не нужен в первую секунду и не должен
  // соперничать за сеть с данными экрана, на который человек пришёл.
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const idle = window.requestIdleCallback;
    if (idle) {
      const handle = idle(() => setReady(true), { timeout: 3000 });
      return () => window.cancelIdleCallback?.(handle);
    }
    const timer = setTimeout(() => setReady(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  const { data } = useQuery({
    queryKey: queryKeys.announcements.active,
    queryFn: () => api.getActiveAnnouncements().catch(() => ({ announcements: [] })),
    enabled: ready,
    // Один запрос на заход: анонс не должен всплывать посреди работы
    // из-за рефетча при возврате фокуса.
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const announcements = data?.announcements ?? [];
  if (announcements.length === 0) return null;

  return (
    <Suspense fallback={null}>
      <AnnouncementModalView announcements={announcements} />
    </Suspense>
  );
}
